import { determineSelector, getResource, readUrl } from "./api";

// Single-row read of a company's profile-completion score (the `company_completion_scores`
// PostgREST view — keyed on the company PromoEntity's id). Mirrors expert_completion_scores.js's
// `getById` shape: callers of this client already have the company's numeric id in hand (it backs a
// decorative rail widget, not a page route).
const getById = async (companyId) => {
  const selector = determineSelector(companyId, { keyId: "id" });
  const url = readUrl("company_completion_scores", { selector });
  return getResource(url);
};

export default { getById };
